import RecordingPreviewMetaData from './RecordingPreviewMetaData'

export default RecordingPreviewMetaData



// WEBPACK FOOTER //
// ./src/legacy/containers/EkgRecordingReviewScreen/components/RecordingPreviewMetaData/index.js